import { render, staticRenderFns } from "./CompanyRequest.vue?vue&type=template&id=72da3d9a&scoped=true"
import script from "./CompanyRequest.vue?vue&type=script&lang=js"
export * from "./CompanyRequest.vue?vue&type=script&lang=js"
import style0 from "./CompanyRequest.vue?vue&type=style&index=0&id=72da3d9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72da3d9a",
  null
  
)

export default component.exports